import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

import {useIsAnnotationModeAvailable} from './useIsAnnotationModeAvailable';

/**
 * Fences adaptive and independent practice apart from `student_annotations`, so the
 * session-only tool can land in steps without exposing a partial surface.
 */
export const SESSION_ONLY_ANNOTATIONS_FLAG = 'student_annotations_session_only';

export function useIsSessionOnlyAnnotationModeAvailable(): boolean {
  const isAnnotationModeAvailable = useIsAnnotationModeAvailable();
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled(SESSION_ONLY_ANNOTATIONS_FLAG);

  return isAnnotationModeAvailable && isFeatureEnabled && !isLoading;
}
